import { render, staticRenderFns } from "./DrugOverlay.vue?vue&type=template&id=04be4582&"
import script from "./DrugOverlay.vue?vue&type=script&lang=js&"
export * from "./DrugOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports